import { LiliError } from '@lili/lili-frontend-common';
import type { ReactNode } from 'react';

export interface DisplayFieldProps {
  label: string;
  value: string;
  disabled?: boolean;
  accessoryComponent?: ReactNode;
  errorMessage?: string;
  dataTestId?: string;
}

export const DisplayField = ({
  label,
  value,
  disabled,
  accessoryComponent,
  errorMessage,
  dataTestId,
}: DisplayFieldProps) => {
  const containerClasses = disabled
    ? 'bg-surface-primary-bw-02 border-outline-primary-bw-03'
    : 'bg-surface-primary-bw-00 border-outline-primary-bw-06';

  const textClasses = disabled ? 'text-text-main-disabled' : 'text-text-main-tertiary';

  const valueClasses = disabled ? 'text-text-main-disabled' : 'text-text-main-primary';

  return (
    <div className='flex flex-col' data-testid={dataTestId}>
      <div
        className={`relative flex items-center h-[54px] rounded-[8px] border pl-[16px] pr-[12px] pt-[5px] pb-[8px] ${containerClasses}`}>
        <div className='flex flex-1 flex-col justify-center gap-px'>
          <span className={`text-[12px] leading-[14px] ${textClasses}`}>{label}</span>
          <span className={`text-[16px] leading-[24px] tracking-[-0.2px] ${valueClasses}`}>
            {value}
          </span>
        </div>
        {accessoryComponent}
      </div>
      {errorMessage && <LiliError errorMessage={errorMessage} />}
    </div>
  );
};
